import { render, staticRenderFns } from "./rl_air_control.vue?vue&type=template&id=86c76ec0&"
import script from "./rl_air_control.vue?vue&type=script&lang=js&"
export * from "./rl_air_control.vue?vue&type=script&lang=js&"
import style0 from "./rl_air_control.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports